import { ModuleWithProviders, NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { GettingStartedComponent } from "./modules/pages/experiences/getting-started/getting-started.component";
import { CallbackComponent } from "./callback/callback.component";
import { ProtectedComponent } from "./modules/pages/protected/protected.component";
// import { ExperiencesWizardComponent } from "./experiences/experiences-wizard/experiences-wizard.component";
import { ExperienceListingComponent } from "./modules/pages/experiences/experience-listing/experience-listing.component";
import { ErrorScreenComponent } from "./modules/pages/error-screen/error-screen.component";
import { ImportExperiencesComponent } from "./modules/pages/experiences/import-experiences/import-experiences.component";
import { CreationPathComponent } from "./modules/pages/experiences/creation-path/creation-path.component";
import { SettingsComponent } from "./modules/pages/settings/settings.component";
import { MembersComponent } from "./modules/pages/members/members.component";
import { QrCodesComponent } from "./modules/pages/qr-codes/qr-codes.component";
import { ExperiencesStepsComponent } from "./modules/pages/experiences/experiences-steps/experiences-steps.component";
import { authGuard } from "@services/guards/auth-guard.service";

const appRoutes: Routes = [
  {
    path: "",
    component: GettingStartedComponent,
    canActivate: [authGuard],
  },
  {
    path: "create-experience/:experienceId",
    component: ExperiencesStepsComponent,
    canActivate: [authGuard],
  },

  {
    path: "active",
    component: ExperienceListingComponent,
    canActivate: [authGuard],
  },
  {
    path: "expired",
    component: ExperienceListingComponent,
    canActivate: [authGuard],
  },
  {
    path: "pendingApproval",
    component: ExperienceListingComponent,
    canActivate: [authGuard],
  },
  {
    path: "bin",
    component: ExperienceListingComponent,
    canActivate: [authGuard],
  },
  {
    path: "rejected",
    component: ExperienceListingComponent,
    canActivate: [authGuard],
  },
  {
    path: "drafts",
    component: ExperienceListingComponent,
    canActivate: [authGuard],
  },
  {
    path: "import",
    component: ImportExperiencesComponent,
    canActivate: [authGuard],
  },
  {
    path: "creation",
    component: CreationPathComponent,
    canActivate: [authGuard],
  },
  {
    path: "protected",
    component: ProtectedComponent,
    canActivate: [authGuard],
  },
  {
    path: "settings",
    component: SettingsComponent,
    canActivate: [authGuard],
  },
  {
    path: "members",
    component: MembersComponent,
    canActivate: [authGuard],
  },
  {
    path: "qr-codes",
    component: QrCodesComponent,
    canActivate: [authGuard],
  },
  {
    path: "callback",
    component: CallbackComponent,
  },
  {
    path: "404",
    pathMatch: "full",
    component: ErrorScreenComponent,
  },
  {
    path: "**",
    redirectTo: "/404",
  },
];


@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
